import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../../user/selectors'
import { getPcrIdSelector } from '../../../home/selectors'
import { IPcr } from '../../../pcr/store/pcr.types'
import { PcrDocsService } from '../../../../services/pcrDocs.service'
import { performWithMutexHOG } from '../../../../services/mutexUtility.service'
import { MotorVehicleIncidentConstants } from '../store/motorVehicleIncident.constants'
import { getMotorVehicleIncidentSelector } from '../selectors'
import { IMotorVehicleIncidentState } from '../store/motorVehicleIncident.types'

export function* saveMotorVehicleIncident() {
  const ccHpiMotorVehicleIncident: IMotorVehicleIncidentState = yield select(getMotorVehicleIncidentSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    try {
      const pcrDocsService = new PcrDocsService(serviceId)
      const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)
      const pcrDocUpdated: IPcr = {
        ...pcrDoc,
        ccHpiMotorVehicleIncident,
      }
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`saveMotorVehicleIncident() error: ${e}`))
    }
  } else {
    yield put(throwPcrException('pcrID not found'))
  }
}

export function* saveMotorVehicleIncidentSaga() {
  yield takeLatest(
    [MotorVehicleIncidentConstants.SAVE_MOTOR_VEHICLE_INCIDENT],
    performWithMutexHOG,
    saveMotorVehicleIncident
  )
}
